import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../pages/shared/auth.service';
import { environment } from '../../environments/environment';
import { createBackUrl } from '../shared-third-party/functions/createBackUrl';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const url: string = state.url;
    const access = this.checkLogin(url);
    if (!access) {
      this.router.navigate(['/auth'], {
        // queryParams: {
        //   backUrl: createBackUrl([environment.baseUrl, this.router.routerState.snapshot.url].join('')),
        // },
      });
    }
    return access;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // return this.canActivate(childRoute, state);
    return true;
  }

  private checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn) {
      return true;
    }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    return false;
  }

  private checkPermission(permission: string) {
    return true;
  }
}
